var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M60 30.999a29.002 29.002 0 01-43.498 25.12A29.002 29.002 0 012 31.004C1.998 14.987 14.981 2.002 30.997 2 47.014 1.998 60 14.982 60 30.999z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A3",
    d: "M20.62 20.617l20.363 20.366m-20.364 0l20.364-20.366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M51.508 51.504L74 74"
  }))));
}

export default SvgNoProducts;